module.exports = __webpack_public_path__ + "static/image12-a0cd7c582f32ba8dfc02adea84fb89e3.jpeg";